export function ExitIcon() {

    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g
      className="neededStroke"
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.8"
        clipPath="url(#clip0_761_2211)"
      >
        <path d="M6.765 14.775H3.904a1.43 1.43 0 01-1.43-1.43V3.33a1.43 1.43 0 011.43-1.43h2.86M11.771 11.914l3.576-3.576-3.576-3.576M15.348 8.338H6.765"></path>
      </g>
      <defs>
        <clipPath id="clip0_761_2211">
          <path className="neededFill" fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
    )
}